import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// 在 router 切換時自動回到頁面最上方
// ref: https://reactrouter.com/web/guides/scroll-restoration/scroll-to-top

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
